const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeadliftsvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "deadlift",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M14.2,7A3,3,0,0,0,15,5,3,3,0,0,0,9,5a3,3,0,0,0,.8,2A3,3,0,0,0,7,10v5a1,1,0,0,0,2,0v6a1,1,0,0,0,2,0V14a1,1,0,0,0-2,0V10a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v4a1,1,0,0,0-2,0v7a1,1,0,0,0,2,0V15a1,1,0,0,0,2,0V10A3,3,0,0,0,14.2,7Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M20,17a1,1,0,0,1-1-1V15H5v1a1,1,0,0,1-2,0,1,1,0,0,1-1-1V13a1,1,0,0,1,1-1,1,1,0,0,1,2,0v1H19V12a1,1,0,0,1,2,0,1,1,0,0,1,1,1v2a1,1,0,0,1-1,1A1,1,0,0,1,20,17Z",
    style: {
      fill: "rgb(44, 169, 188)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadliftsvg);
export default __webpack_public_path__ + "static/media/deadlift.svg.fc985699cef3d0003589b141278214d4.svg";
export { ForwardRef as ReactComponent };